// extracted by mini-css-extract-plugin
export default {"zoomModal":"f0-z","image":"g0-z","button":"h0-z","isOverlayShown":"i0-z"};